import React, { useState,useCallback, useEffect } from 'react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import MerchandiseLineItems from './MerchandiseLineItems'
import { Form, Message, Grid } from 'semantic-ui-react'
import ItemParties from './itemParties/itemParties'
import FiscalReferences from './fiscalReferences'
import { deleteInvoice,updateInvoiceHeader,updateDataAfterSave} from '../../actions'
import { updateMechandiseItemById } from '../../actions/itemTabActions'
import {useSelector,useDispatch } from 'react-redux'
import { useEvent } from '../../hooks/useEvent'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { SAVE_ITEM_CDS } from '../../api/apiEvents'
import { convertDateToUTC,convertDateToUTCEpoch } from '../../../Helper/date'
import InvoiceBar from './invoiceBar'
import ToggleInvoices from '../../../commonComponents/formComponents/toggleInvoices';
import {addItemsTabWarnings,deleteItemsTabWarnings} from "../../actions/errorValidationActions";
import { validation } from '../../util/cdsFieldPatterns';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import { cdsFieldPatterns } from '../../util/cdsFieldPattern'
import { InvoiceToggleContext } from '@commonComponents/accordion/AccordianInvoice'
import { useContext } from 'react'
  



const InvoiceItem = ({
  invoiceItemIndex,
  isFormEnabled,
  invoiceId, 
  validateError, 
  initItemsTabValidationCDS,
}) => {

  const {state}=useContext(InvoiceToggleContext)
  const active=state[invoiceId]

  const dispatch=useDispatch()

  const {isImportShipment} = useCurrentShipmentType()
  const fieldPattern = cdsFieldPatterns(isImportShipment)

  const { deleteForm,isLoading,saveForm }=useEvent("invoice",true)
  

  const setActiveAccordian = () => {
    handleSingleInvoiceToggle(invoiceId) 
  }

  const { declarationCat = '' } = useSelector((state) => state.Shipment) || []

  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'itemsTab'),
    [declarationCat]
  )

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }


  const deleteData=useCallback(async()=>{
    const response=await deleteForm({ "invoiceIds": [invoiceId]})
    if(response){

      const invoiceHeader = response.invoice.invoiceHeader
      const merchandise = response.invoice.merchandise

      dispatch(deleteInvoice(invoiceId,{invoiceHeader,merchandise}))
      dispatch(initItemsTabValidationCDS())

    }

 },[invoiceId,,deleteInvoice,dispatch,deleteForm])


 
 const saveData = useCallback(async(payload)=>{
  const response = await saveForm({"invoiceList":{[invoiceId]:{"header":{...payload}}}},false,SAVE_ITEM_CDS)
},[saveForm,invoiceId])

const saveCurrency = useCallback(async(payload)=>{
  const response = await saveForm({"invoiceList":{[invoiceId]:{"header":{...payload}}}},false,SAVE_ITEM_CDS)
  if(response){
    const invoiceHeader = response.invoice.invoiceHeader
    const header = response.invoice.invoiceList[invoiceId].header
    Object.entries(response.invoice.merchandise).forEach(([key,value])=>{
      dispatch(updateMechandiseItemById(key,value))
    })
    dispatch(updateDataAfterSave(invoiceId,{invoiceHeader,header}))
  }
},[saveForm,invoiceId])



const currencyDropDown = useSelector((state) => state.DropDownValues.currencyTypes)

 const invoiceHeader = useSelector(state=>state.InvoicesReducer.invoice.invoiceList[invoiceId].header)

 const {invoiceNumber,currency,grossMass,invoiceTotal,netMass,poNo,invoiceDate,incoTerms,totalPackages=0,totalItems=0} = invoiceHeader
  const isFormDisabled = isFormEnabled === false
  

  return (
   
          <Message className='invoice'>
            {isLoading && <CustomLoader />}
            <ToggleInvoices 
                titleValue={
                <InvoiceBar
                 invoiceNumber={invoiceNumber}
                 poNo={poNo}
                 grossMass={grossMass}
                 currency={currency} 
                 invoiceTotal={invoiceTotal}
                 netMass={netMass}
                 totalItems={totalItems}
                 totalPackages={totalPackages}
                 />
              }
                invoiceId={invoiceId}
                toggleId={invoiceId}
                title="invoice"
                isFormDisabled={isFormDisabled}
                expandCollapseId={`expandCollapseInvoice-${invoiceId}`}
                deleteItemId={`deleteInvoice-${invoiceId}`}
                lineNumber={invoiceItemIndex+1}
                isActive={active}
                confirmationMsg="Invoice"
                onDelete={deleteData}    
              />
          
            {active && (
              <>
                <Form.Group className='float-container  mg-t-15' widths='equal'>
                  <Grid className='kn__grid'>
                    <Grid.Row>
                      <Grid.Column width='4' className='divFormFeild border-bottom'>
                        <InputField
                          isLabel={false}
                          id={`${invoiceId}-invoiceNumber`}
                          type='text'
                          label='Invoice Number'
                          className={'field-bg'}
                          clearInput={false}
                          value={invoiceNumber || ''}
                          errors={getValidationError("invoiceNumber",invoiceNumber || '')}
                          onChange={(value)=>dispatch(updateInvoiceHeader({invoiceNumber:value,invoiceId}))}
                          onBlur={()=>{saveData({"invoiceNumber":invoiceNumber||' '})
                          let err = getValidationError('invoiceNumber', invoiceNumber || '', 'itemsTab')
                          err.length
                            ? addErrors('itemsTab', `invoice -00${invoiceItemIndex + 1}`+ ' :: ' +err[0], `invoiceNumber-${invoiceId}`)
                            : deleteErrors('itemsTab', '', `invoiceNumber-${invoiceId}`)
                            
                        }}
                          copyToFeature={true}
                        />
                      </Grid.Column>

                      <Grid.Column width='4' className='divFormFeild datePicker'>
                        <InputField
                          isLabel={false}
                          id={`${invoiceId}-invoiceDate`}
                          type='date'
                          label='Invoice Date'
                          className="field-bg"
                          value={convertDateToUTC(invoiceDate)} 
                          clearInput={false}
                          onChange={(value) => {
                            value=convertDateToUTCEpoch(value)
                            dispatch(updateInvoiceHeader({invoiceDate:value,invoiceId}))
                            saveData({"invoiceDate":invoiceDate||' '}) 
                          }
                          }
                         
                        />
                      </Grid.Column>

                      <Grid.Column width='4' className='divFormFeild'>
                        <DropDown
                         id={`${invoiceId}-currency`}
                          label={'CURRENCY'}
                          className='field-bg dropdown100'
                          labelClass='text-none'
                          isLabel={true}
                          data={currencyDropDown}
                          value={currency}
                          onChange={(value)=>{
                               dispatch(updateInvoiceHeader({currency:value,invoiceId}))
                               saveCurrency({"currency":value||" "})
                           }}
                        
                      
                        />
                      </Grid.Column>
                      <Grid.Column
                        width='4'
                        className='divFormFeild border-bottom  b-brr-0 b-trr-5'
                      >
                        <InputField
                          id={`${invoiceId}-invoiceTotal`}
                          isLabel={false}
                          type='text'
                          label='Invoice Total'
                          value={invoiceTotal||''}
                          className={'field-bg'}
                          clearInput={false}
                          disabled={true}
                          // onChange={(value)=>dispatch(updateInvoiceHeader({invoiceTotal:value,invoiceId}))}
                          // onBlur={()=>saveData({"invoiceTotal":invoiceTotal})}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width='4' className='divFormFeild border-bottom '>
                        <InputField
                          id={`${invoiceId}-grossMass`}
                          isLabel={false}
                          type='text'
                          label='Gross Mass'
                          boxNumber='6/5'
                          value={grossMass||''}
                          className={'field-bg'}
                          clearInput={false}
                          disabled={true}
                          // onChange={(value)=>dispatch(updateInvoiceHeader({grossMass:value,invoiceId}))}
                          // onBlur={()=>saveData({"grossMass":grossMass})}

                        />
                      </Grid.Column>
                      <Grid.Column width='4' className=' divFormFeild'>
                        <InputField
                          id={`${invoiceId}-netMass`}
                          isLabel={false}
                          type='text'
                          label='Net Mass'
                          boxNumber='6/1'
                          value={netMass||''}
                          className={'field-bg'}
                          clearInput={false}
                          disabled={true}
                          // onChange={(value)=>dispatch(updateInvoiceHeader({netMass:value,invoiceId}))}
                          // onBlur={()=>saveData({"netMass":netMass})}

                        />
                      </Grid.Column>

                      <Grid.Column width='4' className='divFormFeild b-bw-1'>
                        <InputField
                          id={`${invoiceId}-poNumber`}
                          isLabel={false}
                          type='text'
                          label='po number'
                          value={poNo||''}
                          className={'field-bg'}
                          clearInput={false}
                          onChange={(value)=>dispatch(updateInvoiceHeader({poNo:value,invoiceId}))}
                          onBlur={()=>saveData({"poNo":poNo||' '})}
                          
                        />
                      </Grid.Column>
                      {
                       isImportShipment &&
                       <Grid.Column width='4' className='divFormFeild'>
                        <InputField
                          id={`${invoiceId}-incoterms`}
                          isLabel={false}
                          type='text'
                          label='Incoterms'
                          disabled={true}
                          className={'field-bg'}
                          clearInput={false}
                          value={incoTerms}
                        />
                      </Grid.Column>
                      }
                    </Grid.Row>

                   
                    
                  </Grid>
                </Form.Group>

                <ItemParties  invoiceId={invoiceId}  />
               
                <FiscalReferences invoiceId={invoiceId} /> 

                <MerchandiseLineItems
                  key={`merchandise${invoiceId}`}
                  invoiceId={invoiceId}
                  invoiceItemIndex={invoiceItemIndex}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                  initItemsTabValidationCDS={initItemsTabValidationCDS}
                />
              </>
            )}
          </Message>
       
       
 
  )
}

export default React.memo(InvoiceItem)
